import { $Color } from '@suntex.core/types';
import { $GradeLevel, $MathObjective } from '@suntex.fim/enums';

import { NodeModel } from '../../../types';

import { modulesNode } from './modules';

const title = 'Math Objectives';
const MAX_LABEL_WIDTH = 12;

export const mathObjectivesNode: NodeModel = {
  hidden: true,
  tag: 'math-objectives',
  label: 'Math Objectives',
  info: {
    title: title,
  },
  color: $Color.from('#00b7ff'),
  children: $MathObjective.describeAll().map<NodeModel>((objective) => {
    const multiLineLabel = splitLabelIntoTwoLines(objective.label).join('\n');
    const labelWidth = Math.max(
      ...multiLineLabel.split('\n').map((line) => line.length),
    );
    const abbreviation = objective.label
      .split(' ')
      .map((word) => word[0])
      .join('');
    const isAbbreviated = labelWidth > MAX_LABEL_WIDTH;

    return {
      tag: objective.slug,
      icon: {
        text: isAbbreviated ? abbreviation : multiLineLabel,
      },
      label: isAbbreviated
        ? multiLineLabel
        : {
            aria: objective.label,
          },
      info: {
        title: `${objective.label}`,
        summary: `${title}`,
      },
      color: objective.color,
      layout: 'levels',
      children: $GradeLevel.describeAll().map<NodeModel>((level) => {
        return {
          tag: level.slug,
          icon: {
            text: `${abbreviation}-${level.symbol}`,
          },
          label: {
            aria: level.label,
          },
          info: {
            title: `${objective.label} — ${level.label}`,
            summary: `${title}`,
          },
          filterTagPath: `grade:${level.value}/objective:${objective.value}`,
          filterRoot: modulesNode,
        };
      }),
    };
  }),
};

/* eslint-disable @typescript-eslint/no-non-null-assertion */
function splitLabelIntoTwoLines(label: string): [string, string] {
  let words = label.split(' ').map((line) => line.trim());

  while (words.length > 2) {
    if (words[0]!.length <= words[words.length - 1]!.length) {
      const [first, second, ...rest] = words;
      words = [`${first} ${second}`, ...rest];
    } else {
      const last = words.pop()!;
      const secondLast = words.pop()!;
      words = [...words, `${secondLast} ${last}`];
    }
  }

  return [words[0]!, words[1]!];
}
/* eslint-enable @typescript-eslint/no-non-null-assertion */
